export enum Language {
  Polish = "pl",
  English = "en",
}

export const defaultLanguage = Language.Polish
